module.exports = __webpack_public_path__ + "img/Hippie.8f86de27.svg";